//Prebuilt in theme
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

document.addEventListener('DOMContentLoaded', function () {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return (msie > 0 || trident > 0);
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement('input');
  cartSubmitInput.setAttribute('name', 'checkout');
  cartSubmitInput.setAttribute('type', 'hidden');
  document.querySelector('#cart').appendChild(cartSubmitInput);
  document.querySelector('#checkout').addEventListener('click', function (event) {
    document.querySelector('#cart').submit();
  });
});

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.checkoutBtn = document.getElementById('checkout');
    this.checkoutBtn.addEventListener('click', async (event) =>  {
      event.preventDefault();
      // await this.updateWelcomeJars().then(() => {
        location.href = '/checkout';
      // });
    });

  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.key, event.target.value, document.activeElement.getAttribute('name'));
    //Add custom event when cart updated
    document.body.dispatchEvent(new CustomEvent('cart-updated'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart__items'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-summary',
        section: document.getElementById('main-cart-summary').dataset.id,
        selector: '.main-cart-summary'
      },
      {
        id: 'cart-booster-alert',
        section: document.getElementById('cart-booster-alert').dataset.id,
        selector: '.cart-booster-alert__wrapper'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      id: line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (data) => {

        const parsedState = JSON.parse(data);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-summary');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        this.getSectionsToRender().forEach((section => {
          //console_log(document.getElementById(section.id));
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }));

        document.body.dispatchEvent(new CustomEvent('cart-update'));

        let jars = await this.updateWelcomeJars();


        return data;
      }).catch((err) => {
        console_log(err);

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }


  // getWelcomeKits(){
  //   let welcome_kit_json = document.getElementById('welcome-kit') || false;
  //   if (welcome_kit_json){
  //     let welcome_kits = JSON.parse(welcome_kit_json.textContent);
  //     return welcome_kits;
  //   }
  //   return;
  // }

  async updateWelcomeJars() {
    const data = await this.getCart();
    let cart_items = data.items;
    let products_with_jar = [];
    let products_with_jar_bundle = [];
    let products_with_gifts = [];
    let all_jars = {};
    let jarsInCartKeys = [];
    let jarsInCartKeys_bundle = [];
    let giftsInCartKeys = [];

    // Grab all products with jars from current cart
    for (const cart_item of cart_items) {
      let combinations = 1;
      // For bundles
      if (cart_item.product_type == 'bundle') combinations =  cart_item.quantity; 

      if (cart_item?.properties?._welcome_kit) {
        products_with_jar.push({ [cart_item.key]: cart_item.quantity });
      } 
      if (cart_item?.properties?._item_builder) {
        products_with_jar_bundle.push({ [cart_item.properties._item_builder]: cart_item.quantity });
      } 
      if (cart_item?.properties?._gifts) {
        products_with_gifts.push({ [cart_item.key]: cart_item.quantity });
      }
    }

    
    // jars In Cart Keys array
    jarsInCartKeys = products_with_jar.map(el => Object.keys(el)[0]);
   
    // jars In Cart from builder Keys array 
    jarsInCartKeys_bundle = products_with_jar_bundle.map(el => Object.keys(el)[0]);

    //Gor gift products
    giftsInCartKeys = products_with_gifts.map(el => Object.keys(el)[0]);

    for (const cart_item of cart_items) {
      if (cart_item?.properties?._key) {
        if (cart_item.properties?._type == 'welcome-jar'){
          // if no product with jars all jars = 0
          !products_with_jar.length ? all_jars[cart_item.key] = 0 : null;

          for (const product_with_jar of products_with_jar) {
            const jar_key = Object.keys(product_with_jar)[0];
            const jar_quantity = Object.values(product_with_jar)[0] * cart_item.properties._multiplier;
          
            if (cart_item.properties._key == jar_key) {
              // all_jars[cart_item.key] = jar_quantity;
            } else if (!jarsInCartKeys.includes(cart_item?.properties?._key) || !jarsInCartKeys.length) {
              all_jars[cart_item.key] = 0;
            }
          }
        }
        // Gifts logic (Daily Greens)
       
        if (cart_item.properties?._type == 'gift'){
          !products_with_gifts.length ? all_jars[cart_item.key] = 0 : null;
          
          for (const product_with_gift of products_with_gifts) {
            const gift_key = Object.keys(product_with_gift)[0];
            const gift_quantity = Object.values(product_with_gift)[0];
          
            if (cart_item.properties._key == gift_key) {
              // all_jars[cart_item.key] = gift_quantity;
            }  else if (!giftsInCartKeys.includes(cart_item?.properties?._key) || !giftsInCartKeys.length) {
              all_jars[cart_item.key] = 0;
            }
          }
        }
      }

      // if product from builder
      else if (cart_item?.properties?._item_builder) {
        for (const builder_kit of cart_items) {

          // if product and jars from one bundle
          if (cart_item.properties._item_builder == builder_kit?.properties?._welcome_kit_builder) {
            // all_jars[builder_kit.key] = cart_item.quantity;
          }
        }
      }

      // if product from builder but main item was deleted

      else if (!products_with_jar_bundle.length || cart_item?.properties?._welcome_kit_builder) {
        for (const builder_kit of cart_items) {
          if (builder_kit?.properties?._welcome_kit_builder && !jarsInCartKeys_bundle.includes(builder_kit?.properties?._welcome_kit_builder)) {
            all_jars[builder_kit.key] = 0;
          }
        }
      }
    }

    // Delete MOV product from cart if the cart total == 0 
    if (data.original_total_price / 100 < +locales_variables.free_gift_from) {
      for (const cart_item of cart_items) {
        if (cart_item?.properties?._isMov == 'true' ) {
          all_jars[cart_item.key] = 0;
        }
      }
    }

    Object.keys(all_jars).length > 0 ? this.updateItems(all_jars) : this.disableLoading();
  }

  updateItems = async (updates) => {
    let body = JSON.stringify({
      updates
    });
    return await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => {
        return response.json();
      })
      .then(cart => {
        const itemsData = cart.items.map(el => ({ key: el.key, qty: el.quantity }));
        const itemsKeys = itemsData.map(item => item.key);
        const allQtyInputs = document.querySelectorAll(`[data-key]`);

        allQtyInputs.forEach(input => {
          const key = input.dataset.key;

          if (!itemsKeys.includes(key)) {
            input.closest(".cart-item").remove();
          } else {
            const matchingItem = itemsData.find(item => item.key === key);
            if (matchingItem) {
              input.value = matchingItem.qty;
            }
          }
        });

        if (allQtyInputs.length && !itemsKeys.length) {

          window.location.reload();
        }
        this.disableLoading();
      })
      .catch(err => {
        // location.href = '/checkout';
        console.log(err);
      });
  }

  // async countCartSynbiotics(){
  //   const data = await this.getCart();
  //   let synbiotics_qty = 0;
  //   let items = data.items;

  //   for (const item of items) {
  //     console_log(item)
  //     if (item.product_type != 'jar' && item.product_type != 'addon') {
  //       synbiotics_qty += 1;
  //     }
  //   }

  //   return synbiotics_qty;
  // } 

  async getCart() {
    return await fetch(`/cart.json`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        return data;
      })
      .catch(err => {
        console.err(err);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.querySelector('.loading-spinner').classList.add('active');
    document.querySelector('.cart__details').classList.add('opacity-06');
  }

  disableLoading() {
    document.querySelector('.loading-spinner').classList.remove('active');
    document.querySelector('.cart__details').classList.remove('opacity-06');
  }

}

customElements.define('cart-items', CartItems);



// let checkoutMOVCheck = async () => {

//   let checkout_url = '/checkout'
//   let mov_reached = await checkMOV();

//   if (mov_reached && locales_variables.discount_code_free_gift.length > 0 && locales_variables.free_gift_from.length > 0) {
//     checkout_url = `/checkout?discount=${locales_variables.discount_code_free_gift}`;
//   }

//   location.href = checkout_url;
// }

// const checkMOV = async () => {
//   const cart = await getCart();
//   let giftProductInCart = false;
//   let free_gift_from = parseFloat(locales_variables.free_gift_from);

//   cart.items.forEach(item => {
//     if (item.handle == locales_variables.free_gift_product.handle) {
//       giftProductInCart = true;
//     }
//   });

//   if (giftProductInCart) free_gift_from += parseFloat(locales_variables.free_gift_product.price);

//   if (giftProductInCart && parseFloat(cart.items_subtotal_price / 100) > free_gift_from) {
//     return true;
//   } else {
//     return false;
//   }
// }

// // checkout_btn.addEventListener('click', checkoutMOVCheck);


// Sticky checkout btn
let tablet = window.matchMedia("(max-width: 768px)").matches;

if (tablet) {
  let timeout;
  const addStickyClass = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const element = document.querySelector("#main-cart-summary");
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (rect.top <= window.innerHeight && rect.bottom + 1000 >= 0 && scrollTop > rect.top) {
        element.classList.remove("sticky");
        if (document.getElementById('chat-button')) {
          document.getElementById('chat-button').style.opacity = '1';
        }
      } else {
        element.classList.add("sticky");
        if (document.getElementById('chat-button')) {
          document.getElementById('chat-button').style.opacity = '0';
        }
      }
    }, 100); // Adjust the delay as needed
  }
  window.addEventListener("scroll", addStickyClass);
}

//Allow customers to buy only addons with the parameter ?addons=true
if (localStorage.getItem('canCheckoutWithAddons') == 'true') {
  document.querySelector('#cart__booster-alert').classList.add('hidden');
  document.getElementById('checkout').removeAttribute("disabled");
}